module.exports = __webpack_public_path__ + "static/media/veva-collect-default-download-image.480c2889.jpg";